export enum SortOrder {
  'ascend' = 'ASC',
  'descend' = 'DESC',
}

export const convertUserEmailFilterToEndpointParam = (userEmail: string) => {
  return `userProperties.userEmail||$eq||${userEmail}`;
};

export const convertPropertyFilterToEndpointParam = (currentFilter: any) => {
  switch (currentFilter.type) {
    case 'property':
      return `propertyId||$eq||${currentFilter.key}`;
    case 'propertyManagementCompany':
      return `propertySettings.value||$eq||${currentFilter.key}`;
    default:
      return `propertyId||$notnull`;
  }
};

export const convertGeneralArrayFilterToEndpointParam = (
  filterType: string,
  filterValue: string[],
) => {
  if (!filterValue || filterValue.length === 0) {
    return '';
  }
  return `&filter=fionaAuditsTagAnalysisResult.${filterType}||$in||${filterValue.toString()}`;
};

export const convertSorterToEndpointParam = (sorter: any) =>
  sorter?.field && sorter?.order
    ? `&sort=${sorter.field},${SortOrder[sorter.order as keyof typeof SortOrder]}`
    : '';
